var $ = require('jquery');
var tooltip = function(event){
	var tip = $('.tipReq');
	tip.on(event,function(){
		var thistip = $(this);
		function removeTip(){
			var tipTitle = thistip.find('.tipTitle');
			tipTitle.removeClass('tipTitle--enabled');
			setTimeout(function(){
				tipTitle.remove();
			},350)
		}
		if(thistip.find('.tipTitle').length === 0){
			thistip.append('<span></span>');
			var newTipTitle = thistip.find('span');
			newTipTitle.addClass('tipTitle');
			var thisDataTip = thistip.data('tip');
			newTipTitle.html(thisDataTip);
			setTimeout(function(){
				newTipTitle.addClass('tipTitle--enabled');
			},100);
			if(event === 'mouseenter'){
				thistip.on('mouseleave',function(){
					removeTip();
				});
			}
		}else{
			removeTip();
		}
		
	})
};
module.exports = tooltip;